import Search from "../search/Search";
import Top_Users from "../top_users/Top_Users";

const Right = () => {
    return(
        <div className="right">
            <Search />
            <Top_Users />
        </div>
    )
}

export default Right;